import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertModule } from '../alert/alert.module';
import { LanguageModule } from '../language/language.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ReadOnlyModule } from '../read-only/read-only.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { BlockUnlockAccComponent } from './components/account/block-unlock-acc/block-unlock-acc.component';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { CancelContractComponent } from './components/contract/cancel-contract/cancel-contract.component';
import { SubscriberModule } from '../subscriber/subscriber.module';
import { ExonerationComponent } from './components/account/exoneration/exoneration.component';
import { ExonerationPJComponent } from './components/account/exoneration-pj/exoneration-pj.component';
import { CertificationsComponent } from './components/account/certifications/certifications.component';
import { WithdrawComponent } from './components/account/withdraw/withdraw.component';
import { CancelAccComponent } from './components/account/cancel-acc/cancel-acc.component';
import { StatementAccComponent } from './components/account/statement-acc/statement-acc.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { BlockUnblockContractModalComponent } from './components/contract/block-unblock-contract-modal/block-unblock-contract-modal.component';
import { ContractStatementComponent } from './components/contract/contract-statement/contract-statement.component';
import { MonthYearFieldModule } from '../month-year-field/month-year-field.module';
import { CardFreezeComponent } from './components/cards/card-freeze/card-freeze.component';
import { CardReplacementComponent } from './components/cards/card-replacement/card-replacement.component';
import { CardRestartResendComponent } from './components/cards/card-restart-resend/card-restart-resend.component';
import { BillingPeriodsModalComponent } from './components/contract/billing-periods-modal/billing-periods-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ContractCertificationsComponent } from './components/contract/contract-certifications/contract-certifications.component';
import { InstallmentLoanStatementComponent } from './components/installment-loans/installment-loan-statement/installment-loan-statement.component';

const components = [
  ExonerationComponent,
  ExonerationPJComponent,
  CertificationsComponent,
  BlockUnlockAccComponent,
  WithdrawComponent,
  CancelAccComponent,
  CancelContractComponent,
  StatementAccComponent,
  BlockUnblockContractModalComponent,
  ContractStatementComponent,
  CardFreezeComponent,
  CardReplacementComponent,
  CardRestartResendComponent,
  BillingPeriodsModalComponent,
  ContractCertificationsComponent,
];

@NgModule({
  declarations: [...components, InstallmentLoanStatementComponent],
  exports: [...components],
  imports: [
    CommonModule,
    PipesModule,
    AlertModule,
    LanguageModule,
    MatProgressSpinnerModule,
    ReadOnlyModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatRadioModule,
    MatSelectModule,
    MatCheckboxModule,
    MatInputModule,
    SubscriberModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MonthYearFieldModule,
    MatDialogModule,
  ],
})
export class ModalsModule {}
